import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SubscriptionLimits } from '../services/subscriptionLimitsService';
import { isAdmin } from '../utils/auth';
import '../styles/subscription-limit-modal.css';

interface SubscriptionLimitModalProps {
  open: boolean;
  onClose: () => void;
  limits: SubscriptionLimits | null;
}

export default function SubscriptionLimitModal({ open, onClose, limits }: SubscriptionLimitModalProps) {
  const navigate = useNavigate();
  const userIsAdmin = isAdmin();

  // Don't render if not open
  if (!open) return null;

  // If open but no limits data, still show the modal
  // This handles cases where the API hasn't loaded yet or failed
  const handleViewPlans = () => {
    navigate('/billing');
    onClose();
  };

  return (
    <div className="subscription-limit-modal" role="dialog" aria-modal="true">
      <div className="subscription-limit-modal-card">
        <button className="subscription-limit-modal-close" aria-label="Close" onClick={onClose}>
          ×
        </button>

        <div className="subscription-limit-modal-content">
          <h2 className="subscription-limit-modal-title">
            {userIsAdmin ? "You've reached the limit of your current plan." : "Athlete limit reached."}
          </h2>

          <p className="subscription-limit-modal-description">
            {userIsAdmin
              ? "To continue adding athletes, please upgrade your subscription."
              : "Only an account admin can upgrade your plan. Reach out to your admin if you need additional athlete capacity."
            }
          </p>

          <div className="subscription-limit-modal-actions">
            {userIsAdmin ? (
              <>
                <button
                  className="subscription-limit-modal-btn subscription-limit-modal-btn-secondary"
                  onClick={onClose}
                >
                  Close
                </button>
                <button
                  className="subscription-limit-modal-btn subscription-limit-modal-btn-primary"
                  onClick={handleViewPlans}
                >
                  View plans
                </button>
              </>
            ) : (
              <button
                className="subscription-limit-modal-btn subscription-limit-modal-btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

